import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Sparkles, Mail, Lock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import Seo from "@/components/Seo";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [params] = useSearchParams();

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
            toast.success("Falls die E-Mail existiert, wurde ein Reset-Link gesendet.");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Fehler aufgetreten");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 sm:p-12">
            <Seo title="Passwort vergessen | Bewerbung24.ai" description="Setze dein Passwort für Bewerbung24.ai zurück." path="/passwort-vergessen" noindex />
            <div className="w-full max-w-md">
                <Link to="/" className="flex items-center gap-2 mb-8">
                    <div className="h-9 w-9 rounded-lg flex items-center justify-center" style={{ background: "var(--gradient-primary)" }}>
                        <Sparkles className="text-white" size={18} />
                    </div>
                    <span className="font-heading font-bold tracking-tight">Bewerbung24<span className="gradient-text">.ai</span></span>
                </Link>

                <h1 className="font-heading text-3xl font-bold text-slate-900 tracking-tight">Passwort vergessen?</h1>
                <p className="mt-2 text-slate-600">Wir senden dir einen Link zum Zurücksetzen deines Passworts.</p>

                {done ? (
                    <div className="mt-6 p-6 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800">
                        Falls eine E-Mail mit dieser Adresse existiert, haben wir dir einen Reset-Link gesendet.
                    </div>
                ) : (
                    <form className="mt-8 space-y-4" onSubmit={submit}>
                        <div>
                            <label className="text-sm font-medium text-slate-700">E-Mail</label>
                            <div className="mt-1 relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                                <input
                                    type="email"
                                    required
                                    data-testid="forgot-email-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full pl-10 pr-4 py-3 rounded-lg bg-slate-50 border border-slate-200 focus:border-red-500 focus:ring-2 focus:ring-red-100 outline-none"
                                />
                            </div>
                        </div>
                        <button
                            type="submit"
                            disabled={busy}
                            data-testid="forgot-submit-button"
                            className="w-full py-3 rounded-full font-semibold btn-primary-grad disabled:opacity-60"
                        >
                            {busy ? "Wird gesendet..." : "Reset-Link senden"}
                        </button>
                    </form>
                )}

                <p className="mt-8 text-sm text-slate-600 text-center">
                    Erinnerst dich wieder? <Link to="/login" className="text-red-600 font-semibold hover:underline">Zurück zum Login</Link>
                </p>
            </div>
        </div>
    );
}
